import { assertValue } from '@shared/helpers'
import { PurchaseLoanInfoData } from '@shared/sec-loans'
import { OptionalAndNullable } from '@shared/typeHelpers'
import { convertUndefinedToNull } from '@ui-common/utils/form'
import { numberToString, toNumber } from '@ui-common/utils/helpers'
import { IntlShape } from 'react-intl'

import { PurchaseLoanInfoStepData, StepDataValidator } from '../../../types'
import { isFormDataValid } from '../../../wizardData'
import { createFormValidator } from './formValidator'
import { PurchaseLoanInfoFormData } from './types'

export const convertToFormValues = (
  purchaseLoanInfo: PurchaseLoanInfoStepData | undefined,
): OptionalAndNullable<PurchaseLoanInfoFormData> => {
  return convertUndefinedToNull({
    loanAmount: numberToString(purchaseLoanInfo?.loanAmount),
    loanMonthlyPayment: numberToString(purchaseLoanInfo?.loanMonthlyPayment),
    loanPurpose: purchaseLoanInfo?.loanPurpose,
    loanIssuer: purchaseLoanInfo?.loanIssuer,
    otherPurpose: purchaseLoanInfo?.otherPurpose,
  })
}

export const convertToStepData = (formData: PurchaseLoanInfoFormData): PurchaseLoanInfoStepData => {
  return {
    loanAmount: assertValue(toNumber(formData?.loanAmount), 'formData.loanAmount'),
    loanMonthlyPayment: toNumber(formData?.loanMonthlyPayment),
    loanPurpose: formData?.loanPurpose,
    loanIssuer: formData.loanIssuer || undefined,
    otherPurpose: formData?.otherPurpose,
  }
}

export const getAndValidatePurchaseLoanInfoData: StepDataValidator<PurchaseLoanInfoData | undefined> = ({
  validationData,
  applicationMetadata,
  validationParams,
}) => {
  const metadata = assertValue(applicationMetadata, 'applicationMetadata')
  const minimumPurchaseLoanAmount = assertValue(
    validationParams?.minimumPurchaseLoanAmount,
    'validationParams.minimumPurchaseLoanAmount',
  )
  const createValidator = (formatMessage: IntlShape['formatMessage']) =>
    createFormValidator(formatMessage, metadata.applicationPurpose, minimumPurchaseLoanAmount)

  return isFormDataValid(convertToFormValues(validationData.targetInfo?.purchaseLoanInfo), createValidator)
    ? validationData.targetInfo?.purchaseLoanInfo
    : undefined
}
